module.exports = __webpack_public_path__ + "ca6240598f76e516365856f9d64ec07b.jpg";